if (!customElements.get('vaillant-size-guide-drawer')) {
  class VaillantSizeGuideDrawer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        document.addEventListener('click', this.handleOpen);
        return;
      }
      this.initialized = true;
      this.panel = this.querySelector('.vaillant-size-guide-drawer__panel');
      this.closeButton = this.querySelector('.vaillant-size-guide-drawer__close');
      this.country = this.querySelector('[data-size-guide-country]');
      this.unit = this.querySelector('[data-size-guide-unit]');
      this.handleOpen = this.handleOpen.bind(this);
      document.addEventListener('click', this.handleOpen);

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-size-guide-close]')) this.close();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('active')) this.close();
      });
      this.country.addEventListener('change', () => this.updateCountry());
      this.unit.addEventListener('change', () => this.updateUnits());
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleOpen);
      if (this.classList.contains('active')) this.close();
    }

    handleOpen(event) {
      const trigger = event.target.closest('[data-vaillant-size-guide-open]');
      if (!trigger || trigger.getAttribute('aria-controls') !== this.id) return;
      event.preventDefault();
      this.open(trigger);
    }

    open(trigger) {
      if (this.classList.contains('active')) return;
      this.opener = trigger;
      this.setAttribute('aria-hidden', 'false');
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
      window.scrollLock?.lock();
      if (typeof trapFocus === 'function') trapFocus(this.panel, this.closeButton);
      else this.closeButton.focus();
    }

    close() {
      if (!this.classList.contains('active')) return;
      this.classList.remove('active');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      window.scrollLock?.unlock();
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.opener);
      else this.opener?.focus();
    }

    updateCountry() {
      const country = this.country.value;
      const label = this.country.selectedOptions[0].textContent;
      this.querySelector('[data-size-guide-country-heading]').textContent = label;
      this.querySelectorAll('[data-france][data-italy][data-uk][data-us][data-japan]').forEach((cell) => {
        cell.textContent = cell.dataset[country];
      });
    }

    updateUnits() {
      const useInches = this.unit.checked;
      this.querySelectorAll('[data-cm][data-inches]').forEach((cell) => {
        cell.textContent = useInches ? `${cell.dataset.inches} IN` : `${cell.dataset.cm} CM`;
      });
    }
  }

  customElements.define('vaillant-size-guide-drawer', VaillantSizeGuideDrawer);
}
